import {ChangeDetectionStrategy, Component} from '@angular/core'

/*
  This component is pretty tied to Mobi, so we need to project the content into it:
    recommandedByText: Localised text that says 'recommended by'
    logo: a company logo
    agencyName: the name of the agency
 */
@Component({
  selector: 'cft-recommended-by',
  templateUrl: './recommended-by.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class RecommendedByComponent {}
